// @flow

import * as React from 'react';
import { useContext } from 'react';

import { withPageMeta } from '@gandi/app-runner';
import {
  selectCartIsWorking,
  selectProductsByType,
  selectCartUUID,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { Base, Button } from '@gandi/ui';

import { Intro } from 'src/Layout';
import { Layout } from 'src/components/Layout';

import { useAppSelector } from 'src/hooks';

import {
  CounterStateContext,
  CounterStateProvider,
} from '../Overview/components/Products/components/components/Rows/Counter';

import type { PreFetchArgs } from '../types';

import { MailboxStandaloneForm } from './components/Form';
import { MailboxStandaloneItem } from './components/Item';

const CheckoutButton = () => {
  const { __ } = useTranslator();

  const cartIsWorking = useAppSelector(state => selectCartIsWorking(state));
  const activityState = useContext(CounterStateContext);
  const cartId = useAppSelector(selectCartUUID);

  return (
    <Button
      to={`/cart/${cartId}`}
      loading={cartIsWorking || activityState?.hasActivity}
    >
      {__('Checkout')}
    </Button>
  );
};

const productType = { productType: 'mailbox-standalone' };

function MailboxStandaloneCreateRoot(): React.MixedElement {
  const translator = useTranslator();
  const { __ } = translator;

  const cartProducts = useAppSelector(state =>
    selectProductsByType(state, productType),
  );

  return (
    <Layout>
      <Intro title={__('Buy mailboxes')} />
      <CounterStateProvider>
        {cartProducts.map(product => (
          <MailboxStandaloneItem key={product.id} product={product} />
        ))}
        <Base marginBottom="small">
          <MailboxStandaloneForm />
        </Base>
        {cartProducts.length > 0 && (
          <Base flex flexJustifyEnd>
            <CheckoutButton />
          </Base>
        )}
      </CounterStateProvider>
    </Layout>
  );
}

export const MailboxStandaloneCreate: React.ComponentType<{}> = withPageMeta(
  args => ({
    title: args.__('Buy mailboxes - Gandi.net'),
    description: args.__('Buy mailboxes.'),
  }),
)(MailboxStandaloneCreateRoot);

// $FlowFixMe[prop-missing]
MailboxStandaloneCreate.preFetch = async (args: PreFetchArgs<>) => {
  return Promise.allSettled([
    Layout.preFetch(args),
    MailboxStandaloneForm.preFetch(args),
  ]);
};
